import { render, staticRenderFns } from "./FolhaDePonto.vue?vue&type=template&id=70c24843&scoped=true"
import script from "./FolhaDePonto.vue?vue&type=script&lang=js"
export * from "./FolhaDePonto.vue?vue&type=script&lang=js"
import style0 from "./FolhaDePonto.vue?vue&type=style&index=0&id=70c24843&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c24843",
  null
  
)

export default component.exports